module.exports = __webpack_public_path__ + "img/mj_partners_2.12bec6a6.png";